var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{attrs:{"editorToolbar":_vm.editorToolbar},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }